import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormRadio } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { AbstractKkvStep } from "./AbstractKkvStep";

export const OUTGOING_TRANSFER = [
	{
		label: "50 millió Ft felett",
		value: "+50",
	},
	{
		label: "20-50 millió Ft között",
		value: "20-50",
	},
	{
		label: "10-20 millió Ft között",
		value: "10-20",
	},
	{
		label: "5-10 millió Ft között",
		value: "5-10",
	},
	{
		label: "1,5 - 5 millió Ft között",
		value: "1,5-5",
	},
	{
		label: " 1,5 millió Ft alatt",
		value: "1,5",
	},
];

interface StepFields {
	outgoingTransfer: string;
}

interface Props extends AbstractStepProps, StepFields {}

export class Step1 extends AbstractKkvStep<StepFields, Props> {
	protected initValues(): StepFields {
		const { outgoingTransfer } = this.props;

		return {
			outgoingTransfer,
		};
	}

	protected renderFields(valid: boolean): ReactNode {
		return (
			<>
				<div className="wrapper">
					<FormRadio
						label="Mekkora a céged havi átlag kimenő forgalma?"
						name="outgoingTransfer"
						options={OUTGOING_TRANSFER}
						variant="button"
						required
					/>
				</div>
				<div className="text-center mt-auto">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasArrowRight} />} disabled={!valid}>
						Tovább
					</Button>
				</div>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
